import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
// import PropTypes from 'prop-types';

/***************************************************************************************************
 ********************************************** Styles *********************************************
 **************************************************************************************************/
const DivWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 0 20px 20px;
`;

/***************************************************************************************************
 ********************************************* Component *******************************************
 **************************************************************************************************/
const TestHeightSideNav50Links = props => {
  return (
    <DivWrapper>
      <Link to=''>Item 1</Link>
      <Link to=''>Item 2</Link>
      <Link to=''>Item 3</Link>
      <Link to=''>Item 4</Link>
      <Link to=''>Item 5</Link>
      <Link to=''>Item 6</Link>
      <Link to=''>Item 7</Link>
      <Link to=''>Item 8</Link>
      <Link to=''>Item 9</Link>
      <Link to=''>Item 10</Link>
      <Link to=''>Item 11</Link>
      <Link to=''>Item 12</Link>
      <Link to=''>Item 13</Link>
      <Link to=''>Item 14</Link>
      <Link to=''>Item 15</Link>
      <Link to=''>Item 16</Link>
      <Link to=''>Item 17</Link>
      <Link to=''>Item 18</Link>
      <Link to=''>Item 19</Link>
      <Link to=''>Item 20</Link>
      <Link to=''>Item 21</Link>
      <Link to=''>Item 22</Link>
      <Link to=''>Item 23</Link>
      <Link to=''>Item 24</Link>
      <Link to=''>Item 25</Link>
      <Link to=''>Item 26</Link>
      <Link to=''>Item 27</Link>
      <Link to=''>Item 28</Link>
      <Link to=''>Item 29</Link>
      <Link to=''>Item 30</Link>
      <Link to=''>Item 31</Link>
      <Link to=''>Item 32</Link>
      <Link to=''>Item 33</Link>
      <Link to=''>Item 34</Link>
      <Link to=''>Item 35</Link>
      <Link to=''>Item 36</Link>
      <Link to=''>Item 37</Link>
      <Link to=''>Item 38</Link>
      <Link to=''>Item 39</Link>
      <Link to=''>Item 40</Link>
      <Link to=''>Item 41</Link>
      <Link to=''>Item 42</Link>
      <Link to=''>Item 43</Link>
      <Link to=''>Item 44</Link>
      <Link to=''>Item 45</Link>
      <Link to=''>Item 46</Link>
      <Link to=''>Item 47</Link>
      <Link to=''>Item 48</Link>
      <Link to=''>Item 49</Link>
      <Link to=''>Item 50</Link>
    </DivWrapper>
  );
};

// TestHeightSideNav50Links.propTypes = {
//   propertyName: PropTypes.string
// }

export default TestHeightSideNav50Links;
